import { environmentName } from '@common/Globals/config';
import { load, ReCaptchaInstance } from 'recaptcha-v3';

const siteKey = '6LdwADQaAAAAAMe64a7RTgJ0XTotyYOHx3mYakCw';
const recaptchaResponseTextArea = () => $('#g-recaptcha-response');
const recaptchaBadge = () => $('.grecaptcha-badge');
let recaptcha: ReCaptchaInstance;

async function init() {
	if (environmentName === 'CCIBDEV') return;

	recaptcha = await load(siteKey, {
		explicitRenderParameters: {
			badge: 'bottomleft',
		},
	});

	recaptchaResponseTextArea().attr('title', 'recaptcha response');
	recaptchaBadge().find('iframe').attr('title', 'recaptcha badge');
}

export async function injectReCaptchaToken(ev: JQuery.SubmitEvent, actionName: string): Promise<void> {
	ev.preventDefault();

	const form = ev.currentTarget as HTMLFormElement;
	const captchaInput = document.createElement('input');

	captchaInput.classList.add('d-none');
	captchaInput.name = 'RecaptchaToken';

	if (recaptcha) {
		const token = await recaptcha.execute(actionName);
		captchaInput.value = token;
	} else {
		captchaInput.value = 'no token';
	}

	form.appendChild(captchaInput);
	form.submit();
}

$(init);
